import useTranslate from 'modules/local/useTranslate'
import React, {useContext, useEffect, useMemo, useState} from 'react'
import {getFullAddress, NullAsDefault} from 'views/Shared'
import {bindQueryParam} from "../../functions/routerHelper";
import useAsyncAction from "../../../../modules/asyncCache/useAsyncAction";
import {
    user_checkin_editUserCheckin_Api,
    user_checkin_getMyCheckins_Api,
    user_checkin_removeUserCheckin_Api,
    user_checkin_userCheckin_Api,
    user_checkin_userCheckinSaveOnly_Api
} from "../../../../apis/event";
import {NotificationActionTypes, successNotify} from "../../factory/createNotification";
import {notifyOnError} from "../../factory/createErrorEvent";
import _ from "lodash";
import {FeedProvider} from "../../../../components/Feed/FeedProvider";
import {allActions} from "../../../../components/Feed/TimeLineFeed";
import FeedContext from "../../../../components/Feed/FeedContext";
import {App, Avatar, Image, Modal} from "antd";
import {BsPersonFill} from "react-icons/bs";
import getAvatar from "../../../../helpers/getAvatar";
import getAliasName from "../../../../helpers/getAliasName";
import getTitle from "../../../../helpers/getTitle";
import createConfirmDialog, {createConfirmApproveDialog} from "../../factory/createConfirmDialog";
import {PiWarningCircle} from "react-icons/pi";
import {getType} from "../../../../apis/model/base";
import {ImagePlaceholder} from "../../../../conts/imageBase64";
import {showErrorDialog} from "../../factory/createErrorDialog";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {GoLocation} from "react-icons/go";
import {ItemInformation} from "../../Organization/OrganizationEntity";
import dayjs from "dayjs";
import {LoginContext} from "../../../../components/LoginContext";


export const useCheckinApi = ({
                                  item,
                                  notifyListeners = {
                                      onSuccessCheckedInSaveOnly: undefined,
                                      onErrorCheckedInSaveOnly: undefined,
                                      onSuccessCheckedIn: undefined,
                                      onErrorCheckedIn: undefined,
                                      onSuccessRemoveCheckedIn: undefined,
                                      onErrorRemoveCheckedIn: undefined,
                                      onSuccessEditCheckedIn: undefined,
                                      onErrorEditCheckedIn: undefined
                                  },
                              }) => {
    const t = useTranslate()
    const history = useHistory();
    const {modal} = App.useApp();
    const [checkedInData, setCheckedInData] = useState(null)
    const [myCheckIns, setMyCheckIns] = useState([])
    const login = useContext(LoginContext)

    const {
        onSuccessCheckedInSaveOnly = NullAsDefault,
        onErrorCheckedInSaveOnly = NullAsDefault,
        onSuccessCheckedIn = NullAsDefault,
        onErrorCheckedIn = NullAsDefault,
        onSuccessRemoveCheckedIn = NullAsDefault,
        onErrorRemoveCheckedIn = NullAsDefault,
        onSuccessEditCheckedIn = NullAsDefault,
        onErrorEditCheckedIn = NullAsDefault,
    } = notifyListeners ?? {}
    const onError = notifyOnError(t)


    const {handleAsyncAction: getMyCheckins} = useAsyncAction({
        apiInfo: user_checkin_getMyCheckins_Api,
        onSuccess: (result, data) => {
            const dataItems = _.get(data, 'response.data.data', [])
            setMyCheckIns(dataItems)
        },
    })


    useEffect(() => {
        if (!!login?.id) {
            setTimeout(function () {
                getMyCheckins();
            }, 1000);
        }
    }, [])

    const todayCheckin = myCheckIns.find(i => i?.owner?.id === checkedInData?.owner?.id &&
        new Date(i.checkin_time).toDateString() === new Date().toDateString()
    )

    const hasCheckedInToday = !!todayCheckin
    const checkinTime = todayCheckin?.checkin_time || null

    const checkedInModal = useMemo(() => {
        const owner = !!item?.owner ? item?.owner : item;

        if (!!!checkedInData) return null;

        return (
            <Modal
                className="custom-modal"
                footer={null}
                onCancel={() => {
                    setCheckedInData(null)
                }}
                open={!!checkedInData}
                destroyOnHidden={true}>
                <div className="flex flex-col gap-3">
                    <div className="font-semibold text-green-600 tracking-wide italic">
                        {t('You have successfully checked in')}
                    </div>
                    <div className="flex flex-col border border-color-50 shadow-md rounded-xl">
                        <div className="p-2 background-200 rounded-t-lg rounded-b-0 text-color-300 tracking-wider">
                            {`${t('Hello you')}, `}
                        </div>
                        <div className="p-3 flex flex-col gap-6">
                            <div className="flex flex-col gap-2">
                                <div className="flex items-center gap-2">
                                    <Avatar
                                        icon={<BsPersonFill size={16} className="text-color-500"/>}
                                        src={getAvatar(item?.user)}
                                        size={30}
                                        className="flex flex-col background-200"
                                    />
                                    <div style={{fontStyle: 'normal'}}
                                         className="flex-1 font-bold text-gray-800 tracking-wider">
                                        {getAliasName(item?.user, 'patron_saint')} {' '}
                                        {getTitle(item?.user)}
                                    </div>
                                </div>
                                {hasCheckedInToday ? (
                                    <div className="mt-3 px-3 py-2 bg-green-50 rounded-lg text-base text-green-600 italic tracking-wider">
                                        {t(
                                            `you checked in at this location today at: {time}`,
                                            {time: (
                                                <span className="font-bold text-green-700 tracking-wide">
                                                    {dayjs(checkinTime).format('HH:mm')}
                                                </span>
                                            )}
                                        )}
                                    </div>
                                ) : (
                                    <div className="text-color-300 italic tracking-wider">
                                        {t('you have successfully checked in at this location')}
                                    </div>
                                )}
                            </div>
                            <div className="flex flex-col gap-1">
                                <div className="font-semibold text-gray-700 tracking-wide">
                                    {t('locations')}
                                </div>
                                <div className="w-20 h-1 rounded-full bg-gray-400"/>
                                {getTitle(owner) && (
                                    <div className="mt-3 flex flex-col gap-1">
                                        <div className="space-x-1 font-bold text-base text-gray-800 tracking-wide">
                                            <GoLocation size={12} className="mr-2"/>
                                            {getTitle(owner)}
                                        </div>
                                        {!hasCheckedInToday && (
                                            <ItemInformation
                                                label="address"
                                                value={getFullAddress(owner)}
                                                className="text-xs italic tracking-wider"
                                            />
                                        )}
                                        {(owner?.photo && !hasCheckedInToday) && (
                                            <Image
                                                src={owner?.photo || ImagePlaceholder}
                                                fallback={ImagePlaceholder}
                                                style={{width: '100%', minHeight: 80, maxHeight: 120}}
                                                className="flex flex-col flex-center background-200 rounded-l-lg rounded-r-0 object-cover"
                                                wrapperClassName="rounded-l-lg rounded-r-0"
                                                preview={false}
                                            />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="mt-3 grid grid-cols-2 gap-2 md:gap-6 items-center relative">
                        <div
                            style={{ padding: '5px 15px', borderRadius: '0.5rem', cursor: 'pointer'}}
                            className="flex flex-center text-center bg-blue-100 hover:bg-blue-200 text-blue-600"
                            onClick={() => {history.push("/my-activities?rel=my-checkin")}}>
                            {t("go to check-in list")}
                        </div>
                        <FeedProvider
                            item={{ ...checkedInData }}
                            defaultActions={allActions}>
                            <FeedContext.Consumer>
                                {({handleClick, shareUrl}) => (
                                    <div
                                        className="text-center text-color-200 hover:text-primary cursor-pointer"
                                        onClick={() => {handleClick('quote')}}>
                                        {t("share")}
                                    </div>
                                )}
                            </FeedContext.Consumer>
                        </FeedProvider>
                    </div>
                </div>
            </Modal>
        )
    }, [checkedInData])

    const {handleAsyncAction: onCheckInSaveOnly, ...asyncCheckingInSaveOnly} = useAsyncAction({
        onError: (error, errorObj) => {
            showErrorDialog(t)({
                error, errorObj,
                closable: true,
                maskClosable: true,
                okText: t('got it'),
                cancelText: t('close'),
            })

            onErrorCheckedInSaveOnly(error, errorObj)
        },
        query: bindQueryParam({}),
        apiInfo: user_checkin_userCheckinSaveOnly_Api,
        onSuccess: (result, data) => {
            const owner = _.get(data, 'response.data.owner')
            createConfirmApproveDialog({
                className: 'custom-modal text-base',
                title: t("Save successful"),
                message: (
                    <div className="flex flex-col gap-3">
                        <div>{t("Your visit to this place has been saved successfully.")}</div>
                        {(getTitle(owner)) && (
                            <div className="text-primary font-bold">{getTitle(owner)}</div>
                        )}
                        {owner?.photo && (
                            <Image
                                src={owner?.photo || ImagePlaceholder}
                                fallback={ImagePlaceholder}
                                style={{width: '100%', minHeight: 80, maxHeight: 120}}
                                className="flex flex-col flex-center background-200 rounded-l-lg rounded-r-0 object-cover"
                                wrapperClassName="rounded-l-lg rounded-r-0"
                                preview={false}
                            />
                        )}
                        <div style={{fontStyle: 'normal'}} className="mb-3 text-color-100 tracking-wider">
                            {t('would you like to review the pilgrimage stops')}
                        </div>
                    </div>
                ),
                okText: t('go to check-in list'),
                cancelText: t('got it'),
                okButtonProps: {
                    type: 'primary',
                    className: 'button-rounded-lg no-border',
                },
                onOk: () => {
                    history.push("/my-activities?rel=my-checkin")
                },
                cancelButtonProps: {
                    type: 'text',
                    className: 'button-rounded-lg no-border text-sm text-color-300',
                },
            })

            onSuccessCheckedInSaveOnly(result, data)
        },
    })

    const {handleAsyncAction: onCheckIn, ...asyncCheckingIn} = useAsyncAction({
        onError: (error, errorObj) => {
            createConfirmDialog({
                modal,
                className: 'custom-modal text-base',
                translate: t,
                icon: <PiWarningCircle className="anticon"/>,
                title: t('check-in unsuccessful'),
                message: (
                    <div className="flex flex-col gap-3">
                        <div>{errorObj?.error}</div>
                        <div style={{fontStyle: 'normal'}} className="mb-3 text-color-100 tracking-wider">
                            {t("Would you like to save this place to check in again on your next visit")}
                        </div>
                    </div>
                ),
                okText: t('yes'),
                cancelText: t('ignore'),
                onOk: () => {
                    onCheckInSaveOnly({}, {
                        owner_type: getType(item),
                        owner_id: item?.id
                    })
                },
                okButtonProps: {
                    type: 'primary',
                    className: 'button-rounded-lg no-border',
                },
                cancelButtonProps: {
                    type: 'default',
                    className: 'button-rounded-lg no-border text-color-300',
                },
            })
        },
        query: bindQueryParam({}),
        apiInfo: user_checkin_userCheckin_Api,
        onSuccess: (result, data) => {
            const item = _.get(data, 'response.data') ?? {}
            setCheckedInData(item)

            onSuccessCheckedIn(result, data)
        },
    })

    const {handleAsyncAction: onRemoveCheckIn, ...asyncRemoveCheckingIn} = useAsyncAction({
        onError: (result, data) => {
            onErrorRemoveCheckedIn(result, data)
        },
        query: bindQueryParam({}),
        apiInfo: user_checkin_removeUserCheckin_Api,
        onSuccess: (result, data) => {
            onSuccessRemoveCheckedIn(result, data)
        },
    })

    const {handleAsyncAction: onEditCheckIn, ...asyncEditCheckingIn} = useAsyncAction({
        onError,
        query: bindQueryParam({}),
        apiInfo: user_checkin_editUserCheckin_Api,
        onSuccess: (result, data) => {
            successNotify(NotificationActionTypes.UPDATE, t)
            onSuccessEditCheckedIn(result, data)
        },
    })

    return {
        checkedInModal,
        onCheckInSaveOnly, asyncCheckingInSaveOnly,
        onCheckIn, asyncCheckingIn,
        onRemoveCheckIn, asyncRemoveCheckingIn,
        onEditCheckIn, asyncEditCheckingIn
    }
}



